/**
 * PDP size picker (spec 0072 / ADR-049).
 * Syncs variant id into ATC form + sticky dock; gates ATC until size chosen.
 */
(function () {
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    try {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
    } catch (_) {}
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return `R$ ${value}`;
  }

  /** Spec 0107 / ADR-079 — mesma regra do Liquid. */
  function calcInstallCount(priceCents, max, minCents) {
    const price = Number(priceCents) || 0;
    const cap = Math.min(Math.max(Number(max) || 6, 1), 6);
    const min = Number(minCents) || 15000;
    if (price <= 0 || min <= 0) return 0;
    let count = Math.floor(price / min);
    if (count > cap) count = cap;
    if (count < 2) return 0;
    return count;
  }

  function formatInstallmentsLabel(count, amountMoney) {
    const lang = (document.documentElement.lang || 'pt-BR').toLowerCase();
    if (lang.startsWith('en')) {
      return `${count}x of ${amountMoney} interest-free`;
    }
    return `${count}x de ${amountMoney} sem juros`;
  }

  function updateOffer(priceCents) {
    const offers = document.querySelectorAll('[data-gm-pdp-offer]');
    if (!offers.length) return;

    offers.forEach((offer) => {
      if (!(offer instanceof HTMLElement)) return;
      const max = Number(offer.getAttribute('data-gm-install-max')) || 6;
      const minCents = Number(offer.getAttribute('data-gm-install-min-cents')) || 15000;
      const pixPct = Number(offer.getAttribute('data-gm-pix-pct')) || 0;
      const count = calcInstallCount(priceCents, max, minCents);
      const installmentCents = count > 0 ? Math.floor(priceCents / count) : 0;
      const pixPriceCents =
        pixPct > 0 ? priceCents - Math.floor((priceCents * pixPct) / 100) : 0;
      const cardPaused = offer.getAttribute('data-gm-card-paused') === '1';
      const showInstall = !cardPaused && count > 1 && installmentCents > 0;
      const showPix = pixPct > 0 && pixPriceCents > 0;

      let installEl = offer.querySelector('[data-gm-pdp-installments]');
      let sepEl = offer.querySelector('[data-gm-pdp-offer-sep]');
      let pixEl = offer.querySelector('[data-gm-pdp-pix]');

      if (showInstall) {
        if (!installEl) {
          installEl = document.createElement('span');
          installEl.className = 'gm-pdp-price__installments';
          installEl.setAttribute('data-gm-pdp-installments', '');
          offer.insertBefore(installEl, offer.firstChild);
        }
        installEl.hidden = false;
        installEl.textContent = formatInstallmentsLabel(count, formatMoney(installmentCents));
      } else if (installEl) {
        installEl.hidden = true;
        installEl.textContent = '';
      }

      if (showInstall && showPix) {
        if (!sepEl) {
          sepEl = document.createElement('span');
          sepEl.className = 'gm-pdp-price__offer-sep';
          sepEl.setAttribute('data-gm-pdp-offer-sep', '');
          sepEl.textContent = 'ou';
          const after = installEl || offer.firstChild;
          if (after && after.nextSibling) {
            offer.insertBefore(sepEl, after.nextSibling);
          } else {
            offer.appendChild(sepEl);
          }
        }
        sepEl.hidden = false;
      } else if (sepEl) {
        sepEl.hidden = true;
      }

      if (showPix) {
        if (!pixEl) {
          pixEl = document.createElement('span');
          pixEl.className = 'gm-pdp-price__pix-amount';
          pixEl.setAttribute('data-gm-pdp-pix', '');
          offer.appendChild(pixEl);
        }
        pixEl.hidden = false;
        pixEl.textContent = `${formatMoney(pixPriceCents)} via PIX`;
      } else if (pixEl) {
        pixEl.hidden = true;
      }

      offer.hidden = !(showInstall || showPix);
    });
  }

  function parseVariantsJson(root) {
    const el = root.querySelector('[data-gm-size-variants]') || document.querySelector('[data-gm-size-variants]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function findAtcForm(root) {
    const hero = root.closest('.gm-pdp-hero') || document.querySelector('.gm-pdp-hero');
    if (!hero) return null;
    return (
      hero.querySelector('product-form-component form[data-type="add-to-cart-form"]') ||
      hero.querySelector('form[data-type="add-to-cart-form"]') ||
      hero.querySelector('.gm-atc--pdp form')
    );
  }

  function findProductFormComponent(root) {
    const hero = root.closest('.gm-pdp-hero') || document.querySelector('.gm-pdp-hero');
    return hero?.querySelector('product-form-component') || null;
  }

  function setVariantId(form, pfc, variantId, available) {
    if (!variantId) return;
    const id = String(variantId);
    if (form) {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = id;
        input.disabled = !available;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const btn = form.querySelector('button[name="add"], .gm-pdp-showcase__add-to-cart');
      if (btn) {
        btn.disabled = !available;
        btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      }
    }
    if (pfc) {
      pfc.setAttribute('data-variant-id', id);
    }
    document.dispatchEvent(
      new CustomEvent('gm:size-change', {
        detail: { variantId: id, available: !!available },
      })
    );
  }

  function updatePrice(variant) {
    if (!variant) return;
    const priceRoot = document.querySelector('[data-gm-pdp-price]');
    if (priceRoot) {
      const current = priceRoot.querySelector('.gm-pdp-price__current');
      const compare = priceRoot.querySelector('.gm-pdp-price__compare');
      if (current) current.textContent = formatMoney(variant.price);
      if (compare) {
        if (variant.compareAt > variant.price) {
          compare.textContent = formatMoney(variant.compareAt);
          compare.hidden = false;
          priceRoot.classList.add('gm-pdp-price--sale');
        } else {
          compare.hidden = true;
          priceRoot.classList.remove('gm-pdp-price--sale');
        }
      }
    }
    updateOffer(variant.price);
  }

  function syncUrl(variantId) {
    if (!variantId || !window.history?.replaceState) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    } catch (_) {}
  }

  function initPicker(picker) {
    const data = parseVariantsJson(picker);
    const buttons = [...picker.querySelectorAll('[data-gm-size-option]')];
    const valueEl = picker.querySelector('[data-gm-size-value]');
    const hint = picker.querySelector('[data-gm-size-hint]');
    const form = findAtcForm(picker);
    const pfc = findProductFormComponent(picker);
    const requireSelection = picker.getAttribute('data-require-selection') === 'true';

    let selectedId = picker.getAttribute('data-preselect-variant') || '';
    if (selectedId) {
      const match = buttons.find((b) => b.getAttribute('data-variant-id') === selectedId && !b.disabled);
      if (!match) selectedId = '';
    }

    function applySelection(btn, { pushUrl } = { pushUrl: true }) {
      const variantId = btn.getAttribute('data-variant-id');
      const size = btn.getAttribute('data-size') || '';
      const available = btn.getAttribute('data-available') === 'true';
      buttons.forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (valueEl) valueEl.textContent = size;
      if (hint) hint.hidden = true;
      selectedId = variantId;
      setVariantId(form, pfc, variantId, available);
      const variant = data?.variants?.find((v) => String(v.id) === String(variantId));
      updatePrice(variant);
      if (pushUrl) syncUrl(variantId);
    }

    function gateAtc() {
      if (!requireSelection || selectedId) return;
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input) input.disabled = true;
        const btn = form.querySelector('button[name="add"], .gm-pdp-showcase__add-to-cart');
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
      }
      if (hint) hint.hidden = false;
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        applySelection(btn);
      });
    });

    if (selectedId) {
      const pre = buttons.find((b) => b.getAttribute('data-variant-id') === selectedId);
      if (pre && !pre.disabled) applySelection(pre, { pushUrl: false });
      else gateAtc();
    } else {
      gateAtc();
    }

    if (form) {
      form.addEventListener(
        'submit',
        (event) => {
          if (requireSelection && !selectedId) {
            event.preventDefault();
            event.stopPropagation();
            if (hint) hint.hidden = false;
          }
        },
        true
      );
    }
  }

  function boot() {
    document.querySelectorAll('[data-gm-size-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
